import type {
  AtualizarImobilizadoDto,
  CriarImobilizadoDto,
  ImobilizadoResponse,
  ListarImobilizadosQuery,
} from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/** Imobilizados da empresa (GET /imobilizados): `centro.ver`. Valor e depreciacao so vem com `custo.ver`. */
export function useImobilizados(q: Partial<ListarImobilizadosQuery> = {}) {
  return useConsulta<ImobilizadoResponse[]>(['imobilizados'], '/imobilizados', { query: q });
}

/** Um imobilizado (GET /imobilizados/:id). */
export function useImobilizado(id: string | undefined) {
  return useConsulta<ImobilizadoResponse>(['imobilizados', id], `/imobilizados/${id}`, { ativo: !!id });
}

/** Criacao (POST /imobilizados): `centro.editar`. Exige valor, entao so quem tem `custo.ver` cria. */
export function useCriarImobilizado() {
  return useMutacao<ImobilizadoResponse, CriarImobilizadoDto>({
    metodo: 'POST',
    caminho: () => '/imobilizados',
    corpo: (v) => v,
    invalidar: [['imobilizados'], ['centros']],
  });
}

/** Alteracao (PATCH /imobilizados/:id): `centro.editar`. Sem `custo.ver` o corpo nao leva valorUnitario. */
export function useAtualizarImobilizado() {
  return useMutacao<ImobilizadoResponse, { id: string } & AtualizarImobilizadoDto>({
    metodo: 'PATCH',
    caminho: (v) => `/imobilizados/${v.id}`,
    corpo: ({ id: _id, ...resto }) => resto,
    invalidar: [['imobilizados'], ['centros']],
  });
}
